import { render } from "./SmartPressPopup.vue?vue&type=template&id=d55f5a0a&scoped=true"
import script from "./SmartPressPopup.vue?vue&type=script&lang=js"
export * from "./SmartPressPopup.vue?vue&type=script&lang=js"

import "./SmartPressPopup.vue?vue&type=style&index=0&id=d55f5a0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d55f5a0a"]])

export default __exports__